import { render, staticRenderFns } from "./RemoveDeleteReasonModal.vue?vue&type=template&id=2e95e21d&"
import script from "./RemoveDeleteReasonModal.vue?vue&type=script&lang=js&"
export * from "./RemoveDeleteReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports